import type { FC } from 'react'
import Box from '@mui/material/Box'
import { Outlet } from 'react-router-dom'
import { SettingsSidebar } from './settings-sidebar'
import { settingsContentAreaSx } from './settings-content-area-sx'
import { SettingsUnsavedChangesProvider } from './settings-unsaved-changes'
import { APP_FRAME_GAP } from '@/constants/appFrame'

export const SettingsLayout: FC = () => {
  return (
    <SettingsUnsavedChangesProvider>
      <Box
        component="main"
        sx={{
          display: 'flex',
          flex: 1,
          // Dans le cadre d'application, la bande du haut est prise sur la hauteur (TEC-1956).
          minHeight: `calc(100vh - ${APP_FRAME_GAP})`,
        }}
      >
        <SettingsSidebar />
        <Box sx={settingsContentAreaSx}>
          <Outlet />
        </Box>
      </Box>
    </SettingsUnsavedChangesProvider>
  )
}
